module.exports = __webpack_public_path__ + "static/face-0eacbde5125baa7d695d175816438da8.png";